import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':workOrderId'}/condensed`;

export const ROUTE: RouteDefinition = `${baseRoute}/:workOrderId/condensed`;

export const URL = (workOrderId: number): RouteDefinition => `${baseRoute}/${workOrderId}/condensed`;
